var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorePosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6842 2.31579H1.15789V0H19.6842V2.31579ZM11.5789 13.3158C11.5789 14.6358 12.0768 16.0484 12.7368 17.3684V18.5263H1.15789V11.5789H0V9.26316L1.15789 3.47368H19.6842L20.4947 7.52632C19.6842 7.15579 18.8505 6.94737 17.9474 6.94737C14.4737 6.94737 11.5789 9.8421 11.5789 13.3158ZM10.4211 11.5789H3.47368V16.2105H10.4211V11.5789ZM22 13.3158C22 16.3263 17.9474 20.8421 17.9474 20.8421C17.9474 20.8421 13.8947 16.3263 13.8947 13.3158C13.8947 11.1158 15.7474 9.26316 17.9474 9.26316C20.1474 9.26316 22 11.1158 22 13.3158ZM19.3368 13.4316C19.3368 12.7368 18.6421 12.0421 17.9474 12.0421C17.2526 12.0421 16.5579 12.6211 16.5579 13.4316C16.5579 14.1263 17.1368 14.8211 17.9474 14.8211C18.7579 14.8211 19.4526 14.1263 19.3368 13.4316Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorePosition);
export default __webpack_public_path__ + "static/media/storePosition.5fa42058.svg";
export { ForwardRef as ReactComponent };